import Vue from 'vue';
import './plugins/axios';
import App from './App.vue';
import router from './common/router';
import vuetify from './plugins/vuetify';
import store from './common/store';
import axios from 'axios';
import moment from "moment";
import { i18n } from '@/plugins/i18n';

Vue.config.productionTip = false;

const token = localStorage.getItem('user-token');
if (token) {
  axios.defaults.headers.common['Authorization'] = token;
}

Vue.filter('date', (value: string) => {
  if (value) {
    return moment(new Date(value)).format('DD.MM.YYYY');
  }
});
Vue.filter('time', (value: string) => {
  if (value) {
    return moment(new Date(value)).format('hh:mm');
  }
});
Vue.filter('dateTime', (value: string) => {
  if (value) {
    return moment(new Date(value)).format('DD.MM.YYYY hh:mm');
  }
});

new Vue({
  router,
  vuetify,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
